import axios from "axios";
import { useURL } from "../data/Config";
import { IInterview } from "../types";

export const getAllInterviewsByAdmin = async (
  searchQuery?: string
): Promise<IInterview[]> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get<IInterview[]>(
    `${useURL}/interviews/admin/get-all-interviews`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        searchQuery,
      },
    }
  );

  return response.data;
};
export const getInterviewCount = async (): Promise<number> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get<number>(`${useURL}/interviews/admin/count`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
